module.exports = __webpack_public_path__ + "img/slide-right.b9e6003f.svg";